export function sizeToWidthAndHeight(
  size: "ONE_X_ONE" | "TWO_X_ONE" | "TWO_X_TWO" | "TWO_X_THREE" | "TWO_X_FOUR"
): { w: number; h: number } {
  switch (size) {
    case "ONE_X_ONE":
      return { w: 1, h: 1 };
    case "TWO_X_ONE":
      return { w: 2, h: 1 };
    case "TWO_X_TWO":
      return { w: 2, h: 2 };
    case "TWO_X_THREE":
      return { w: 2, h: 3 };
    case "TWO_X_FOUR":
      return { w: 2, h: 4 };
  }
  throw new Error("did nopt fin size" + size);
}
